enum BiteLogPrinterEvent {
  OK = 0,
  ConnectError = 1,
  ConnectTimeout = 2,
  Disconnected = 3,
  PowerOff = 4,
  AddCommandsError = 5,
  SendError = 6,
  PrintJobFail = 7,
  PrintJobTimeout = 8,
  CoverOpen = 9,
  PaperLow = 10,
  PaperEmpty = 11,
  DiscoveryStartError = 14,
  CoverClosed = 15,
  ScannerConnectError = 16,
  ScannerDisconnected = 17,
  ScaleConnectError = 18,
  ScaleDisconnected = 19,
  QueueEnterFail = 20,
  QueueCheckFail = 21,
  QueueingDisabled = 22,
  PrintJobRequested = 23,
  PrintJobSucceed = 24,
  PaperOK = 25,
  CutterError = 26,
  MechanicalError = 27,
  AutoRecoverError = 28,
  UnrecoverableError = 29,
  RecoverableError = 30,
}

export { BiteLogPrinterEvent };
